module.exports = __webpack_public_path__ + "img/bannerLabel1Blue.19b6ec08.png";